import React from "react";

export default function Footer() {
  const links: { label: string; href: string; download?: string }[] = [
    { label: "GitHub ↗", href: "https://github.com/nvimbtw" },
    { label: "LinkedIn ↗", href: "https://www.linkedin.com/in/tadej-gungl-037064320/" },
    { label: "Email ↗", href: "mailto:tadejgungl@gmail.com" },
    { label: "Download CV ↓", href: "/resume.pdf", download: "tadej-gungl-cv.pdf" },
  ];

  return (
    <footer id="contact" className="w-full bg-Base border-t hairline selection:bg-Sapphire selection:text-Base">
      {/* Contact block */}
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-28 md:py-36 flex flex-col items-center text-center">
        <div className="flex items-baseline gap-3 mb-6">
          <span className="section-number">06</span>
          <span className="label-caps">Get in touch</span>
        </div>

        <h2 className="font-display font-light text-Text text-5xl md:text-7xl mb-6">
          Let&apos;s <span className="italic">talk</span>.
          {/* Let&apos;s talk. */}
        </h2>

        <p className="text-Subtext0 font-sans text-lg max-w-md mb-12">
          I&apos;m always on the lookout for interesting opportunities.
        </p>

        <div className="flex flex-wrap justify-center gap-x-10 gap-y-4">
          {links.map((link) => (
            <a
              key={link.label}
              href={link.href}
              download={link.download}
              target={link.href.startsWith("http") ? "_blank" : undefined}
              rel={link.href.startsWith("http") ? "noopener noreferrer" : undefined}
              className="font-mono text-xs uppercase tracking-[0.15em] text-Text border-b hairline pb-1 hover:text-Sapphire hover:border-Sapphire transition-colors duration-200"
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="w-full border-t hairline">
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row justify-between items-center gap-2">
          <span className="font-display italic text-Text text-base">Tadej Gungl</span>
          <span className="font-mono text-xs text-Subtext0">© 2026 · Maribor, Slovenia</span>
        </div>
      </div>
    </footer>
  );
}
